import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'

import { ContentBox, Button } from '@portal/kit/pkg/components'
import RanRoomCard from './../ran-room-card'
import { datetimeToLocaleString } from 'helpers/date'

import styles from './ran-room-style'

const Devices = ({ classes, data, resetRoom, t, i18n }) =>
  <div className={classes.deviceList}>
    <table>
      <thead>
        <tr>
          <th>{t('ran_room.devices.name')}</th>
          <th className={classes.deviceListDesktopOnly}>{t('ran_room.devices.mac')}</th>
          <th>{t('ran_room.devices.since')}</th>
        </tr>
      </thead>
      <tbody>
        {data.devices.map(device =>
          <tr key={device.mac_address}>
            <td>{device.name}</td>
            <td className={classes.deviceListDesktopOnly}>{device.mac_address}</td>
            <td>{datetimeToLocaleString(device.session_start, i18n.language)}</td>
          </tr>
        )}
        {data.devices.length === 0 &&
         <tr><td colSpan="3" className={classes.noDevices}>{t('ran_room.no_devices')}</td></tr>
        }
      </tbody>
    </table>

    <p className={classes.resetSection}>
      <Button onClick={resetRoom} icon='sync-alt'>
        {t('ran_room.reset_button')}
      </Button>
    </p>
  </div>

const RanRoom = props => {
  const classes = styles(props.theme)
  const sharedProps = { ...props, classes }

  return (
    <ContentBox title={props.t('ran_room.manage_title')}>
      <RanRoomCard data={props.data} />
      <button className={classes.devicesButton} onClick={props.toggleDevices}>
        <span className={classNames('fal', 'fa-phone-laptop', classes.devicesButtonIcon)} />
        <span dangerouslySetInnerHTML={{ __html: props.t('ran_room.devices_button') }} />
        <span className={classNames('fal', 'fa-chevron-down', classes.devicesButtonArrow, { [classes.devicesButtonArrowUp]: props.showDevices })} />
      </button>
      {props.showDevices && <Devices {...sharedProps} />}
    </ContentBox>
  )
}

RanRoom.propTypes = {
  data: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  showDevices: PropTypes.bool.isRequired,
  toggleDevices: PropTypes.func.isRequired,
  resetRoom: PropTypes.func.isRequired,
}

export default compose(
  withTranslation(),
  withTheme
)(RanRoom)
